























































































































import {Component, Prop, Watch} from 'vue-property-decorator'
import {Dapp} from '@/model/resource/Dapp'
import {TokensTableItemsCollection} from '@/model/collection/TokensTableItemsCollection'
import {NftCollectionCollection} from '@/model/collection/NftCollectionCollection'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {OrbitProjectCollection} from '@/model/collection/OrbitProjectCollection'
import DappDetailedTablesHeader from './DappDetailedTablesHeader.vue'
import DappDetailedTokensContent from './DappDetailedTokensContent.vue'
import DappDetailedOrbitContent from './DappDetailedOrbitContent.vue'
import DappDetailedNftsContent from './DappDetailedNftsContent.vue'

@Component({
  components: {
    DappDetailedTablesHeader,
    DappDetailedTokensContent,
    DappDetailedNftsContent,
    DappDetailedOrbitContent,
  },
})
export default class DappDetailedTablesSection extends MixinScreenSize {
  @Prop({type: Dapp, required: true}) dapp!: Dapp
  @Prop({type: TokensTableItemsCollection, required: true})
  tokensTableItemsCollection!: TokensTableItemsCollection
  @Prop({type: NftCollectionCollection, required: true})
  nftCollectionCollection!: NftCollectionCollection
  @Prop({type: OrbitProjectCollection, required: true})
  orbitProjectCollection!: OrbitProjectCollection

  selectedTable: 'tokens' | 'nfts' | 'orbit' = 'tokens'

  get isOrbitEnabled(): boolean {
    return this.$auth?.global?.isOrbitFeatureActive !== false
  }

  get existsOrbitProjects() {
    return this.isOrbitEnabled && !this.orbitProjectCollection.isEmpty()
  }

  get existsNfts() {
    return !this.nftCollectionCollection.isEmpty()
  }

  get existsTokens() {
    return !this.tokensTableItemsCollection.isEmpty()
  }

  mounted() {
    this.syncSelectedTableFromAvailability()
  }

  @Watch('existsTokens')
  @Watch('existsNfts')
  @Watch('existsOrbitProjects')
  onTableAvailabilityChange() {
    this.syncSelectedTableFromAvailability()
  }

  syncSelectedTableFromAvailability() {
    if (this.selectedTable === 'tokens' && !this.existsTokens) {
      if (this.existsNfts) {
        this.selectedTable = 'nfts'
      } else if (this.existsOrbitProjects) {
        this.selectedTable = 'orbit'
      }
    } else if (this.selectedTable === 'nfts' && !this.existsNfts) {
      if (this.existsTokens) {
        this.selectedTable = 'tokens'
      } else if (this.existsOrbitProjects) {
        this.selectedTable = 'orbit'
      }
    } else if (this.selectedTable === 'orbit' && !this.existsOrbitProjects) {
      if (this.existsTokens) {
        this.selectedTable = 'tokens'
      } else if (this.existsNfts) {
        this.selectedTable = 'nfts'
      }
    }
  }

  get thereIsNoTable() {
    return !this.existsTokens && !this.existsNfts && !this.existsOrbitProjects
  }

  get existsOnlyOneTable() {
    const existsOnlyTokens =
      this.existsTokens && !this.existsNfts && !this.existsOrbitProjects
    const existsOnlyNfts =
      this.existsNfts && !this.existsTokens && !this.existsOrbitProjects
    const existsOnlyOrbit =
      this.existsOrbitProjects && !this.existsNfts && !this.existsTokens

    return existsOnlyTokens || existsOnlyNfts || existsOnlyOrbit
  }

  handleSelectedTable(table: 'tokens' | 'nfts' | 'orbit') {
    this.selectedTable = table
  }
}
